import { useState, useEffect } from "react";
import MetaHead from "components/base/MetaHead";
import Text from "components/base/Text";
import MainContainer from "components/sections/MainContainer";
import EventPostItem from "components/blocks/EventPostItem";
import TextHeader from "components/sections/TextHeader";
import { allowedLocales } from "translations";
import Trans from "components/base/Trans";
import { useRouter } from "next/router";
import {
  MotionContainer as Container,
  MotionGrid as Grid,
  MotionBox as Box,
  staggeredAppear,
  appearBelow,
} from "utils/motion";
import { getAllEvents, getEventsPage } from "lib/payloadApi";

export default function Post({ initialPosts }) {
  const [{ allPosts, page, loading }, setPageState] = useState({
    allPosts: initialPosts,
    page: 1,
    loading: false,
  });
  const router = useRouter();

  useEffect(() => {
    const selectedLocale =
      allowedLocales.indexOf(router.locale) > -1 ? router.locale : null;
    getEventsPage(1, selectedLocale).then((newPage) => {
      setPageState({ allPosts: newPage, page: 1, loading: false });
    });
  }, [router.locale]);

  useEffect(() => {
    if (loading) {
      const selectedLocale =
        allowedLocales.indexOf(router.locale) > -1 ? router.locale : null;
      getEventsPage(page, selectedLocale).then((newPage) => {
        const newPostsObject = Object.assign(allPosts, {
          results: allPosts.results.concat(newPage.results),
          page,
        });

        setPageState({ allPosts: newPostsObject, page, loading: false });
      });
    }
  }, [page]);
  return (
    <MainContainer
      navStyle={{ gradient: true, inverted: false }}
      style={{ bg: "gray.900" }}
    >
      <MetaHead
        title="LBL_EVENTS_TITLE"
        description="LBL_EVENTS_SUBTITLE"
        imageUrl="/images/meta/events.jpg"
      />
      <TextHeader
        mx={[0, 0, 16]}
        bg="gray.900"
        inverted
        title={<Trans id="LBL_EVENTS_TITLE" />}
        description={<Trans id="LBL_EVENTS_SUBTITLE" />}
      />

      <Container
        initial="hidden"
        animate="visible"
        pt="xl"
        variants={staggeredAppear}
      >
        <Grid variants={appearBelow} templateColumns={["1fr"]}>
          {allPosts.results.map((post) => (
            <EventPostItem key={post.uid} data={post.data} />
          ))}
        </Grid>
        {allPosts.results.length === 0 && (
          <Box w="100%" align="center" py="xl">
            <Text
              type="title_lg"
              color="primary"
              align="center"
              py="xl"
              w="70%"
            >
              <Trans id="LBL_EVENTS_EMPTY_LIST" />
            </Text>
          </Box>
        )}
      </Container>
    </MainContainer>
  );
}

export async function getServerSideProps(ctx) {
  const selectedLocale =
    allowedLocales.indexOf(ctx.locale) > -1 ? ctx.locale : null;

  const allPosts = await getAllEvents(selectedLocale);

  return {
    props: { initialPosts: allPosts },
  };
}
